import React, { useState , useEffect,useRef,useMemo ,useCallback } from 'react';
import { connect } from 'react-redux';
import SelectOptionButton from '../../../Shared/SelectOptionButton/SelectOptionButton';
import TextInput from '../../../Shared/TextInput/TextInput';
import { validateInput , TextInputEnum} from '../../../../utilities/validation/InputValidation';
import BtnNextStep from '../BtnNextStep';
import { BusinessWorkOrderSystemStep ,MessageContent  , GenericInputType} from '../Constant/Constant';
import { createBusinessWorkOrder , setStayInformedChoice,setStayInformedEmail,setGeneralMessage} from '../BusinessWorkOrderSystemSlice';
import { StayInformedChoiceEnum } from '../Constant/Constant';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';

const WorkOrderConfirmation = ({
     customerEmail,
     createBusinessWorkOrder ,
     orgId ,
     selectedWorkOrderType,
     params,
     informedEmail,
     setStayInformedEmail,
     stayInformedValue = StayInformedChoiceEnum.MAIL,
     setStayInformedChoice,
     files,
     setGeneralMessage,
     isReopenWorkOrder,
     currentRow}) => {

    const [error, setError] = useState('');
    const [nextStep, setNextStep] = useState(null);
    const [email, setEmail] = useState(informedEmail || customerEmail);
    const emailRef = useRef(null);


    useEffect(() => {
        if (stayInformedValue !== StayInformedChoiceEnum.MAIL) {
            setError('');
        }
    }, [stayInformedValue]);

    const handleEmailChange = useCallback((value) => {
        const validationError = validateInput(value, TextInputEnum.Mail, true);
        setEmail(value);
        setError(validationError);
    }, []);

    const renderMailInput = useCallback(() => (
        <MailInput
          email={email}
          error={error}
          handleEmailChange={handleEmailChange}
          emailRef={emailRef}
        />
      ), [email, error, handleEmailChange]);


    const buttonsData = useMemo(() => [
        { value: StayInformedChoiceEnum.MAIL, label: 'כן , למייל', openComponent: renderMailInput },
        { value: StayInformedChoiceEnum.NO, label: 'לא' },
        { value: StayInformedChoiceEnum.SMS, label: 'כן ב SMS' }
      ].map(config => ({
        ...config,
        selected: stayInformedValue === config.value
      })), [stayInformedValue, renderMailInput]);



      const formatAddressFields = (addressValue, fieldDefinitions) => {
        if (!addressValue) return '';

        const parts = fieldDefinitions
            .map(({ hebrewName, fieldName }) => {
                const value = addressValue[fieldName];
                if (value != null && value !== '') {
                    return `${hebrewName}: ${value}`;
                }
                return null;
            })
            .filter(part => part !== null);

        return parts.join(' , ');
    };


    const getParamValue = (param) => {
        if(param.paramCode == 'ADDRESS'){
            const addressFields = [
                { hebrewName: 'שם יישוב', fieldName: 'cityName' },
                { hebrewName: 'רחוב', fieldName: 'streetName' },
                { hebrewName: 'בית', fieldName: 'home' },
                { hebrewName: 'דירה', fieldName: 'apartment' },
                { hebrewName: 'קומה', fieldName: 'floor' },
                { hebrewName: 'קוד דואר', fieldName: 'zipCode' }
            ];
            return formatAddressFields(param.value.selectedAddress, addressFields);
           }
            if(param.dropdownOptions != null && !isNullOrEmpty(param.value)){
                if( [GenericInputType.PricePlan , GenericInputType.BAN].includes(param.paramTypeDefinition.paramType)){
                    return param.value.key;
            }else{
                return param.value.value;
            }
            }else{
                return param.value;
            }

    }


    const handleNextStep = async () => {
        if (stayInformedValue === StayInformedChoiceEnum.MAIL) {
            const validationError = validateInput(email, TextInputEnum.Mail, true);
            if (validationError) {
                setError(validationError);
                return false;
            }
        }

        if (stayInformedValue === StayInformedChoiceEnum.MAIL) {
            setStayInformedEmail(email);
        }
        var data = {
                email: email,
                workOrderParams : Object.values(params).map(p => ({
                    paramCode:  p.paramCode,
                    paramValue: getParamValue(p) ?? "",
                    isUnconditional: p.unconditionalParam,
                    isRegularParam : p.isRegularParam
                })),
                fuType: selectedWorkOrderType.type,
                orgId: orgId,
                informedChoice: stayInformedValue,
                fu_link: window.location.origin + window.location.pathname,
                uploadFiles: files,
                isReopenWo: isReopenWorkOrder,
                reopenWorkOrderData: {
                    text: currentRow?.textAreaValue ?? "",
                    title: currentRow?.title ?? currentRow?.futpSystemTxt + ' : ' + currentRow?.futpFuDescription,
                    workOrderId: currentRow?.fuId,
                }
            }
             var res = await createBusinessWorkOrder(data)
            if(res.payload.isSuccess){
                 return BusinessWorkOrderSystemStep.WorkOrderCreationSuccedded;
            } else{
                    setGeneralMessage(MessageContent.GeneralError);
             }

        return BusinessWorkOrderSystemStep.GeneralMessage;
    }

  return (
    <div className="stay-informed-choice">
        <div className='l-title'>האם תרצו לקבל עדכון בנושא הפניה?</div>
        <SelectOptionButton buttonsData={buttonsData} onClick={(value)=>setStayInformedChoice(value)} />
        <BtnNextStep
            onClick={handleNextStep}
            text='אישור ושליחה'
            error={error}
            errorText='כדי להמשיך יש למלא את כל שדות החובה'
       />
    </div>
  );
};

const mapStateToProps = (state) => ({
  params: state.businessWorkOrderSystem.workOrderParams,
  selectedWorkOrderType: state.businessWorkOrderSystem.selectedWorkOrderType,
  orgId: state.portalsBlock.selectedHetPayId,
  stayInformedValue: state.businessWorkOrderSystem.stayInformedValue,
  customerEmail: state.authentication?.loginData?.userDetails?.CustomerEmail,
  informedEmail: state.businessWorkOrderSystem.stayInformedEmail,
  files: state.businessWorkOrderSystem.files,
  isReopenWorkOrder: state.businessWorkOrderSystem.isReopenWorkOrder,
  currentRow: state.businessWorkOrderSystem.selectedWorkOrderRow,
});

const mapDispatchToProps = {
    createBusinessWorkOrder,
    setStayInformedChoice,
    setStayInformedEmail,
    setGeneralMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderConfirmation);


export const MailInput = ({email,error,handleEmailChange,emailRef}) => {

    return (
        <div className='input-container'>
            <TextInput placeholder='כתובת מייל'
                    value={email}
                    error={error}
                    onChange={(e)=>handleEmailChange(e.target.value)}
                    ref={emailRef} />
        </div>
    )
}
